import React from 'react';
import Header from './components/header';
import FeaturedSlider from './components/featured-slider';
import NearbyEvents from './components/search-events/nearby-events';
import nearbyCards from './cards.json';
import OnlineEvents from './components/online-events/online-events';
import InfoSection from './components/info-section';
import CallToAction from '../discover/components/cta-section';
import LatestOnEvedo from './components/latest/latest';
import initLocationAutocomplete from './initAutocomplete';
import organizers from './organizers.json';
import venues from './venues.json';

export class Homepage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            headerSearchQuery: '',
            featuredCards: [],
            isLoaded: false,
            nearbyEventCards: [],
            nearbyEventCardsToShow: 5,
            eventsWhenSelected: 'Whenever',
            eventsCategorySelected: 'all',
            latestSelected: 'performers',
            latestOnEvedo: [],
            cardsLength: 0,
            onlineEvents: [],
            cityData: {},
            viewAllLink: 'search/?&categories='+Object.keys(this.props.categories).map(key => key),
            moreEventsAvailable: true
        }
        this.loadMore = this.loadMore.bind(this);
        this.eventsWhenSwitch = this.eventsWhenSwitch.bind(this);
        this.switchEventCategory = this.switchEventCategory.bind(this);
        this.handleHeaderSearchParams = this.handleHeaderSearchParams.bind(this);
        this.handleLatestOnEvedo = this.handleLatestOnEvedo.bind(this);
        this.loadNearbyEvents = this.loadNearbyEvents.bind(this);
        this.handleHeaderSearchSubmit = this.handleHeaderSearchSubmit.bind(this);
    }
    componentDidMount(){
        /* Get featured events */
        fetch('/featured-events-loader/?pageId=1')
            .then(res => res.json())
            .then((result) => (
                this.setState({
                    featuredCards: Object.values(result.events)
                })
            ))
        
        /* Get online events */
        fetch('/online-events-loader/?pageId=1')
        .then(res => res.json())
        .then((result) => (
            this.setState({
                onlineEvents: Object.values(result.events)
            })
        ))


        /*Get nearby events */
        this.loadNearbyEvents(`pageId=1${this.props.currentCityId ? '&cityId='+this.props.currentCityId : ''}`) // to replace city id with city data 
        
        if(!this.state.isLoaded){
            this.setState({ 
                featuredCards: this.state.featuredCards.length ? this.state.featuredCards : nearbyCards,
                nearbyEventCards: this.state.nearbyEventCards.length ? this.state.nearbyEventCards : [],
                isLoaded: true,
                latestOnEvedo: organizers ? organizers : [],
                isLoaded: true
            });
            /* Get latest promoters */
            // fetch( this.props.domain + '/promoters.json').then(res=>res.json())
            // .then((result) => (
            //     this.setState({
            //         latestOnEvedo: result
            //     },
            //     console.log(result))
            // ))
            initLocationAutocomplete(document.querySelector("#location-autocomplete"), this);
        }
    }
    loadNearbyEvents(params){
        fetch(`/events-loader/${params}`)
        .then(res => res.json())
        .then((result) => {
            this.setState({
                nearbyEventCards: Object.values(result.events),
                cardsLength: result.eventsToLoad <= result.totalCount ? result.eventsToLoad : result.totalCount,
                moreEventsAvailable: this.state.nearbyEventCardsToShow < result.totalCount ? true : false
            })
        })
    }
    handleHeaderSearchParams(e){
        let val = e.target.value;
        e.target
        this.setState({
                headerSearchQuery:  val ? val : this.state.headerSearchQuery
        });
    }
    handleHeaderSearchSubmit(e){
        e.preventDefault();
        let cd = this.state.cityData;
        let city = cd.city !== null ? cd.city +',' : '';
        let cityName = cd.city !== null ? '&city-name='+cd.city : '';
        let coords = cd.city !== null ? '&lat='+cd.lat+'&lng='+cd.lng : '';
        let queryString = `/${this.state.headerSearchQuery !== '' ? '&name='+this.state.headerSearchQuery : ''}${Object.values(cd).length ? '&location='+ city +cd.country + cityName +'&country-code='+cd.countryCode+coords : ''}`;
        window.location = window.location.href + 'search'+queryString;
    }
    loadMore(e){ // load more nearby event cards
        e.preventDefault();
        this.setState({ 
            nearbyEventCardsToShow: this.state.nearbyEventCardsToShow+3 < this.state.cardsLength ? this.state.nearbyEventCardsToShow+3 : this.state.cardsLength
         })
         if(this.state.nearbyEventCardsToShow == this.state.cardsLength && this.state.moreEventsAvailable){
            window.location = window.location.href + this.state.viewAllLink;
         }
         
    }
    eventsWhenSwitch(e){
        e.preventDefault();
        let el = e.target;
        let when = 
            el.getAttribute('data-when') == 'Today' ?
            'today' :
            el.getAttribute('data-when') == 'This Weekend' ?
            'weekend' :
            el.getAttribute('data-when') == 'This Week' ?
            'week' :
            el.getAttribute('data-when') == 'This Month' ?
            'month' : '';

        this.loadNearbyEvents(`${this.state.eventsCategorySelected !== 'all' ? this.state.eventsCategorySelected+'/' : ''}?pageId=1&timelimit=${when}`)
        this.setState({
            eventsWhenSelected: el.getAttribute('data-when'),
            eventsWhenKey: when
        });
    }
    switchEventCategory(e){
        let el = e.target;
        let when = this.state.eventsWhenKey ? '&timelimit='+this.state.eventsWhenKey : '';
        this.loadNearbyEvents(`${el.getAttribute('data-cat')}/?pageId=1&cityId=${this.props.currentCityId}${when}`)
        e.preventDefault();
        let currentCategory = el.getAttribute('data-cat') !== 'all' ? Object.values(this.props.categories).filter((cat) => cat.name_plural.toLowerCase() == el.getAttribute('data-cat')) : [ {id: Object.keys(this.props.categories).map(key => key)}];
        this.setState({
            eventsCategorySelected: el.getAttribute('data-cat'),
            viewAllLink: 'search/?&categories=' + currentCategory[0].id
        });
    }
    handleLatestOnEvedo(e){
        e.preventDefault();
        let el = e.target;
        // el.getAttribute('data-latest') == 'venues' ?
        //     fetch( this.props.domain + '/venues.json',{ mode: 'no-cors' })
        //     .then((result) => (
        //         this.setState({
        //             latestOnEvedo: result,
        //             latestSelected: 'venues'
        //         })
        //     )) 
        // :
        //     fetch( this.props.domain + '/promoters.json',{ mode: 'no-cors' })
        //     .then((result) => (
        //         this.setState({
        //             latestOnEvedo: result,
        //             latestSelected: 'promoters'
        //         })
        //     ))
        this.setState({
            latestOnEvedo: el.getAttribute('data-latest') == 'venues' ? venues : organizers,
            latestSelected: el.getAttribute('data-latest') == 'venues' ? 'venues' : 'performers'
        })
    }
    render(){
        return (
            <div className="bg-white">
                <Header handleSubmit={this.handleHeaderSearchSubmit} categories={this.props.categories} currentCategory={this.props.currentCategory} mode={'light'} handleChange={this.handleHeaderSearchParams} content={this.props.texts.header} page={"home"}/>
                <div className="container">
                    {this.state.featuredCards.length ?
                        <FeaturedSlider cardTexts={this.props.texts.event_card} categories={this.props.categories} currentCategory={this.props.currentCategory} cards={this.state.featuredCards} content={this.props.texts.featured_events}/>
                        : ''}
                    <NearbyEvents cardTexts={this.props.texts.event_card} moreEvents={this.state.moreEventsAvailable} content={this.props.texts.events} categories={Object.values(this.props.categories)} props={this.props} eventsCategorySelected={this.state.eventsCategorySelected} eventsWhenSelected={this.state.eventsWhenSelected} cardsLength={this.state.cardsLength} cards={this.state.nearbyEventCards} cardsToShow={this.state.nearbyEventCardsToShow} loadMore={this.loadMore} switchEvents={this.eventsWhenSwitch} switchEventCategory={this.switchEventCategory}/>
                    <OnlineEvents viewAllLink={this.state.viewAllLink} cardTexts={this.props.texts.event_card} cards={this.state.onlineEvents} content={this.props.texts.online_events} categories={Object.values(this.props.categories)}/>
                    <InfoSection content={this.props.texts.about}/>
                </div>
                <CallToAction content={this.props.texts.marketplace} trusted={this.props.texts.trusted} isLogged={this.props.isLogged}/>
                {/* <div className="bg-dark-violet container-fluid overflow-hidden mt-5">
                    <LatestOnEvedo props={this.props} selected={this.state.latestSelected} slides={this.state.latestOnEvedo} changeSlides={this.handleLatestOnEvedo} content={this.props.latestEvedoSection}/>
                </div> */}
            </div>
        );
    }
}
